if (!customElements.get('collection-banner-slider')) {
  customElements.define(
    'collection-banner-slider',
    class CollectionBannerSlider extends HTMLElement {
      connectedCallback() {
        this.enableSlider = this.dataset.enableSlider === 'true';

        if (!this.enableSlider) return;
        if (!window.FoxTheme || !window.FoxTheme.Carousel) return;

        this.initSlider();
      }

      disconnectedCallback() {
        if (this.carousel && this.carousel.slider) {
          this.carousel.slider.destroy(true, true);
        }
      }

      initSlider() {
        this.sliderControls = this.querySelector('.swiper-controls');

        const additionModules = [FoxTheme.Swiper.Autoplay];

        const sliderOptions = {
          slidesPerView: 1,
          loop: true,
          grabCursor: true,
          allowTouchMove: true,
          threshold: 2,
        };

        if (this.sliderControls) {
          sliderOptions.navigation = {
            nextEl: this.sliderControls.querySelector('.swiper-button-next'),
            prevEl: this.sliderControls.querySelector('.swiper-button-prev'),
          };
          sliderOptions.pagination = {
            el: this.sliderControls.querySelector('.swiper-pagination'),
            clickable: true,
          };
        }

        const autoplayDelay = parseInt(this.dataset.autoplay);
        if (autoplayDelay > 0) {
          sliderOptions.autoplay = {
            delay: autoplayDelay,
            disableOnInteraction: false,
          };
        }

        this.carousel = new window.FoxTheme.Carousel(this, sliderOptions, additionModules);
        this.carousel.init();
      }
    }
  );
}
